import { 
	GET_PROJECT_QA_WELDING_INSPECTIONS_FILLET_SIZES, 
	GET_PROJECT_QA_WELDING_INSPECTIONS_FILLET_SIZE,
	CREATE_PROJECT_QA_WELDING_INSPECTIONS_FILLET_SIZE,
	UPDATE_PROJECT_QA_WELDING_INSPECTIONS_FILLET_SIZE,
	DESTROY_PROJECT_QA_WELDING_INSPECTIONS_FILLET_SIZE,
} from "./actions"

export function ProjectQaWeldingInspectionsFilletSizesReducer(state = {}, action) {
	switch (action.type) {
		case `${GET_PROJECT_QA_WELDING_INSPECTIONS_FILLET_SIZES}_FULFILLED`:{
			return _.mapKeys(action.payload.data, "id");
		}
		case `${GET_PROJECT_QA_WELDING_INSPECTIONS_FILLET_SIZE}_FULFILLED`:
		case `${CREATE_PROJECT_QA_WELDING_INSPECTIONS_FILLET_SIZE}_FULFILLED`:
		case `${UPDATE_PROJECT_QA_WELDING_INSPECTIONS_FILLET_SIZE}_FULFILLED`:{
			let newState = _.clone(state);
			const newItem = action.payload.data;
			const id = _.get(newItem,"id")
			newState[id] = newItem
			return newState;
		}		
		case `${DESTROY_PROJECT_QA_WELDING_INSPECTIONS_FILLET_SIZE}_FULFILLED`:{
			let newState = _.clone(state);
			const deletedItem = action.payload.data;
			const id = _.get(deletedItem,"id")
			newState = _.filter(newState,i => i.id != id)
			return newState;
		}
		default:
			return state;
	}
}

// Move this to the reducer page
// import { ProjectQaWeldingInspectionsFilletSizesReducer } from "modules/project/qa/welding_inspections/fillet_sizes/reducer"

// project_qa_welding_inspections_fillet_sizes:ProjectQaWeldingInspectionsFilletSizesReducer,
